import { render, staticRenderFns } from "./MenuMapaBase.vue?vue&type=template&id=3fc1f58b&scoped=true"
import script from "./MenuMapaBase.vue?vue&type=script&lang=js"
export * from "./MenuMapaBase.vue?vue&type=script&lang=js"
import style0 from "./MenuMapaBase.vue?vue&type=style&index=0&id=3fc1f58b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1f58b",
  null
  
)

export default component.exports